import React from "react";
import { Link } from "react-router-dom";

const Page404 = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="text-center">
        <h1 className="display-1 fw-bold">404</h1>
        <p className="fs-3">
          {" "}
          <span className="text-rosso">Opps!</span> Pagina non trovata.
        </p>
        <p className="lead">La pagina che stai cercando non esiste</p>
      </div>
    </div>
  );
};

export default Page404;
